import { useSearchParams } from 'react-router'

import { SUBMENU_ACCOUNT_PARAM_KEY } from '../../../../constants/route'
import { useSubMenu } from '../../../../hooks'
import {
  getSubMenuEmailsAccountsList,
  getSubMenuEmailsActiveValue,
} from '../../EmailSubMenu'
import { useEmailAccount } from '../useEmailAccount'

export function useEmailGetActiveAccount() {
  const [searchParams] = useSearchParams()

  const account = searchParams.get(SUBMENU_ACCOUNT_PARAM_KEY)

  const subMenu = useSubMenu()

  const activeAccount = getSubMenuEmailsActiveValue(
    account,
    getSubMenuEmailsAccountsList(subMenu.accounts)
  )

  const { account: accountInfo } = useEmailAccount(activeAccount)

  return { account, accountInfo, activeAccount }
}
